var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiPremium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4698 25.0833H7.16667V7.16667H25.0833V15.7308C27.2039 14.3615 29.7689 13.8574 32.25 14.3226V10.75H28.6667V7.16667C28.6638 6.21718 28.2854 5.30739 27.614 4.636C26.9426 3.96461 26.0328 3.58617 25.0833 3.58333H21.5V0H17.9167V3.58333H14.3333V0H10.75V3.58333H7.16667C6.21718 3.58617 5.30739 3.96461 4.636 4.636C3.96461 5.30739 3.58617 6.21718 3.58333 7.16667V10.75H0V14.3333H3.58333V17.9167H0V21.5H3.58333V25.0833C3.58617 26.0328 3.96461 26.9426 4.636 27.614C5.30739 28.2854 6.21718 28.6638 7.16667 28.6667H10.75V32.25H14.3333V28.6667H17.9167V32.25H21.5V28.681C20.9319 27.5578 20.5823 26.337 20.4698 25.0833Z",
    fill: "url(#paint0_linear_2018_7896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3506 35.0665L30.7804 25.5833H36.6251L34.0482 35.0661L34.0474 35.0692C34.027 35.146 33.9819 35.2139 33.9189 35.2624C33.856 35.3108 33.7788 35.3371 33.6994 35.3371C33.62 35.3371 33.5428 35.3108 33.4798 35.2624C33.4169 35.2139 33.3717 35.146 33.3514 35.0692L33.3506 35.0665ZM39.0744 18.4166L39.0754 18.4166C39.1489 18.4165 39.2211 18.4369 39.2838 18.4754C39.3463 18.514 39.3969 18.5692 39.4299 18.6348C39.4299 18.6349 39.43 18.635 39.43 18.6351L41.5068 22.7916H39.4399L37.9086 18.4166L39.0744 18.4166ZM28.3244 18.4166H29.4939L27.9641 22.7916H25.8923L27.9705 18.6351C27.9706 18.6351 27.9706 18.635 27.9706 18.6349C28.0035 18.5693 28.054 18.5142 28.1164 18.4757C28.1789 18.4371 28.2509 18.4166 28.3244 18.4166C28.3244 18.4166 28.3244 18.4166 28.3244 18.4166ZM27.8882 25.5833L29.2185 30.4892L26.0637 25.5833H27.8882ZM41.335 25.5833L38.186 30.4797L39.5175 25.5833H41.335ZM30.9225 22.7916L32.4508 18.4166H34.9484L36.4826 22.7916H30.9225Z",
    fill: "url(#paint1_linear_2018_7896)",
    stroke: "url(#paint2_linear_2018_7896)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3589 19.7083L16.4982 17.2308H13.1335L12.2728 19.7083H10.75L14.0244 10.75H15.6254L18.8938 19.7083H17.3589ZM16.125 15.9737L15.2884 13.5327C15.2563 13.4269 15.2101 13.2784 15.1499 13.0872C15.0897 12.8919 15.0295 12.6946 14.9693 12.4953C14.9092 12.2919 14.859 12.121 14.8189 11.9827C14.7787 12.1495 14.7286 12.3366 14.6684 12.5441C14.6122 12.7475 14.556 12.9387 14.4999 13.1177C14.4477 13.2967 14.4076 13.4351 14.3795 13.5327L13.5368 15.9737H16.125Z",
    fill: "url(#paint3_linear_2018_7896)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0554 19.7083V10.7866H21.5V19.7083H20.0554Z",
    fill: "url(#paint4_linear_2018_7896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2018_7896",
    x1: 16.125,
    y1: 0,
    x2: 16.125,
    y2: 32.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296BD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2018_7896",
    x1: 33.6994,
    y1: 17.9166,
    x2: 33.6994,
    y2: 35.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296BD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2018_7896",
    x1: 33.6994,
    y1: 17.9166,
    x2: 33.6994,
    y2: 35.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296BD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2018_7896",
    x1: 14.859,
    y1: 10.335,
    x2: 14.859,
    y2: 19.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4560C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2018_7896",
    x1: 14.859,
    y1: 10.335,
    x2: 14.859,
    y2: 19.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4560C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPremium);
export default __webpack_public_path__ + "static/media/AI Premium.d39256899dcd233a05cca03aba9c5895.svg";
export { ForwardRef as ReactComponent };